import  { UsersPage } from './pages/UsersPage'
import {UpdateUserPage} from "@/features/users/pages/UpdateUserPage.jsx";
import {InviteUserPage} from "@/features/users/pages/InviteUserPage.jsx";

export const usersRoutes = {
  path: 'users',
  children: [{
    path: '',
    element: <UsersPage />,
    children: [{
      path: 'invite',
      element: <InviteUserPage />,
    }, {
      path: ':id',
      element: <UpdateUserPage />,
    }],
  }],
};
